import { waitLoad } from "@blax-modules/base-front-end/resources/js/utilities/load"
import  {TemplateConstant} from "../../../../../../resources/js/templateConstant";

export class Menu {
    constructor() {
        waitLoad().then(() => {
            this._bindButton();
            this._bindNav();
            this._closeMenuResize();
        })
    }

    _bindNav() {
        let icoBtn = document.querySelectorAll('.ico-menu');
        for (let i in icoBtn) {
            if (icoBtn.hasOwnProperty(i)) {
                let btn = icoBtn[i];
                btn.addEventListener('click', () => {
                    let mobileNav = document.querySelector('.site-mobile-nav');
                    if (mobileNav.classList.contains('in-left')) {
                        mobileNav.classList.remove('in-left')
                        mobileNav.classList.add('in-right')
                    } else if (mobileNav.classList.contains('in-right')) {
                        mobileNav.classList.add('in-left')
                        mobileNav.classList.remove('in-right')
                    } else {
                        mobileNav.classList.add('in-left')
                    }
                })
            }
        }

    }

    _bindButton() {
        let openBtn = document.querySelector('#open-menu-button')
        let menu = document.querySelector('.hamburger-ctn')
        let bodyEl = document.querySelector('body');
        const templateValue = new TemplateConstant();

        if (menu && !templateValue.noBurgerOpen) {
            menu.addEventListener('click', () => {
                openBtn.checked = !openBtn.checked;
                menu.classList.toggle('opened')
                bodyEl.classList.toggle('menu-open')
                this._setupWhenGdprIsOpen(menu.classList.contains('opened'));
            })
        }
        //everything after the header should close the menu
        let afterMenuEl = document.querySelectorAll('.site-header ~ *');
        for (let i in afterMenuEl) {
            if (afterMenuEl.hasOwnProperty(i)) {
                let el = afterMenuEl[i];
                el.addEventListener('click', () => {
                    document.querySelector('body').classList.remove('mobile-menu-open')
                })
            }
        }

        //the escape key also closes the menu
        document.addEventListener('keydown', (evt) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = (evt.key === "Escape" || evt.key === "Esc");
            }
            if (isEscape) {
                if(menu && menu.classList.contains('opened')) {
                    menu.classList.remove('opened')
                    bodyEl.classList.remove('menu-open')
                }
            }
        });
    }

    _setupWhenGdprIsOpen(val) {
        const headerNav = document.querySelector('.site-header__nav');
        const siteHeader = document.querySelector('.site-header');
        const gdprMessage = document.querySelector('.gdpr-message');
        const navWrapper = document.querySelector('.site-navigation__wrapper');

        if(gdprMessage && headerNav && siteHeader && navWrapper) {
            const gdprHeight = gdprMessage.offsetHeight;
            if(val) {
                headerNav.style.top = gdprHeight + 'px';
            } else {
                headerNav.style.top = '';
                siteHeader.style.top = '';
                navWrapper.style.minHeight = '';
            }
            if(gdprMessage && gdprMessage.querySelector('.gdpr-close')) {
                gdprMessage.querySelector('.gdpr-close').addEventListener('click', ()=> {
                    headerNav.style.top = '';
                    siteHeader.style.top = '';
                    navWrapper.style.minHeight = '';
                })
            }
        }
    }
    _closeMenuResize(){
        let menutarget = document.querySelector('.bodyContainer ');
        let menuIconChange = document.querySelector('.hamburger-ctn');
        let width = document.body.clientWidth;
        function closeMenu (){
            if(document.body.clientWidth >= 1220){
                menutarget.classList.remove('menu-open');
                menuIconChange.classList.remove('opened');
            }
        }

       window.addEventListener('resize',closeMenu);
    }
}
